<template>
  <main class="service-page">
    <header class="service-hero">
      <p class="brand">清北博雅 · 学员服务说明</p>
      <h1>学习保障与重修服务说明</h1>
      <p class="lead">备考需要持续投入，也需要清晰的后续安排。清北博雅在相应保障班型中设置重修支持、复试衔接、协议约定的退费或奖励安排，帮助学员在认真备考的同时，对自己的课程权益与后续学习路径更有把握。</p>
      <div class="hero-note"><strong>权益确认更清晰：</strong>报名前可查看班型对应权益，签约时可确认适用条款；已报名学员可依据本人所报课程与签署协议，申请对应保障服务。</div>
    </header>

    <div class="keypoints">
      <article class="key"><strong>保障内容看得明白</strong><p>含保障的班型会对应重修、复试、退费或奖励等权益说明，便于报名选择。</p></article>
      <article class="key"><strong>后续学习有安排</strong><p>符合协议约定的学员，可按流程申请相应支持，延续备考规划。</p></article>
      <article class="key"><strong>办理路径更清楚</strong><p>核对班型与协议后，通过服务老师提交申请并落实对应权益。</p></article>
    </div>

    <section class="service-section">
      <div class="section-head"><h2>选择保障班型，可获得哪些支持</h2><span class="sub">不同课程方向会配置相应的权益组合</span></div>
      <div style="display:grid;grid-template-columns:repeat(4,1fr);gap:12px;">
        <article class="benefit-card" v-for="b in benefits" :key="b.label"><span class="benefit-label">{{ b.label }}</span><h3>{{ b.title }}</h3><p>{{ b.desc }}</p></article>
      </div>
    </section>

    <section class="service-section">
      <div class="section-head"><h2>部分保障课程方向一览</h2><span class="sub">以下为常见保障方向，具体以本人所选产品说明及协议为准</span></div>
      <div style="display:grid;grid-template-columns:repeat(2,1fr);gap:12px;">
        <article class="prog-card" v-for="p in programs" :key="p.icon">
          <div class="prog-icon">{{ p.icon }}</div>
          <div>
            <h3>{{ p.title }}</h3>
            <p class="prog-name">{{ p.name }}</p>
            <p>{{ p.desc }}</p>
            <span class="pill" v-for="t in p.tags" :key="t">{{ t }}</span>
          </div>
        </article>
      </div>
      <div class="callout-box" style="display:flex;gap:14px;align-items:flex-start;margin-top:18px;padding:15px 17px;background:#fbf1f2;border:1px solid #e8d0d3;border-radius:12px;color:#65454a;font-size:14px;"><b style="white-space:nowrap;">如何确认最准确？</b><span>选课时可请老师对照所报班型展示具体权益；签约后，您可在协议中查看重修、复试、奖励或协议安排的适用条件、申请方式与服务范围。</span></div>
    </section>

    <section class="service-section">
      <div class="section-head"><h2>保障服务如何办理</h2><span class="sub">从权益确认到服务落实，流程清晰可核对</span></div>
      <div class="steps-line steps-5">
        <article class="step"><div class="num">01</div><h3>确认课程班型</h3><p>查看本人订单、班型与对应协议。</p></article>
        <article class="step"><div class="num">02</div><h3>核对保障权益</h3><p>明确可申请的重修、复试或其他支持。</p></article>
        <article class="step"><div class="num">03</div><h3>准备申请信息</h3><p>按服务指引整理相应核对材料。</p></article>
        <article class="step"><div class="num">04</div><h3>提交服务申请</h3><p>通过老师提供的服务渠道进行办理。</p></article>
        <article class="step"><div class="num">05</div><h3>落实学习安排</h3><p>审核确认后衔接对应课程或权益。</p></article>
      </div>
    </section>

    <section class="service-section">
      <div class="section-head"><h2>学员可以提前确认的关键信息</h2><span class="sub">确认清楚，再安心进入备考</span></div>
      <div class="support-grid">
        <article class="support-card"><b>我的具体班型</b><span>确认课程名称、全科或单科、线上或线下，以及是否为保障类产品。</span></article>
        <article class="support-card"><b>包含哪些支持</b><span>查看重修、复试课程、协议安排或奖励支持中哪些适用于本人。</span></article>
        <article class="support-card"><b>如何申请办理</b><span>了解申请时间、服务渠道以及需要配合提供的核对信息。</span></article>
        <article class="support-card"><b>重修学习范围</b><span>确认重修的课程方向、服务期限和具体衔接安排。</span></article>
        <article class="support-card"><b>复试与后续服务</b><span>如班型包含复试支持，可提前了解课程开通与使用方式。</span></article>
        <article class="support-card"><b>协议约定内容</b><span>对于退费或奖励等约定，按本人签署协议中的条款执行。</span></article>
      </div>
    </section>

    <section class="service-section">
      <div class="section-head"><h2>清晰说明，安心备考</h2><span class="sub">保障是学习路径的支持，也是双方约定的落实</span></div>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;">
        <article class="device-card"><div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px;"><h3>对学员而言</h3><span class="badge-tag">权益可查询</span></div><ul style="margin:0;padding-left:20px;color:#282224;font-size:14px;"><li style="margin:9px 0;padding-left:4px;">在选择课程前，了解与自身目标匹配的保障配置。</li><li style="margin:9px 0;padding-left:4px;">在签署协议时，确认本人享有的权益与申请方式。</li><li style="margin:9px 0;padding-left:4px;">在需要办理时，依据条款获得相应学习支持。</li></ul></article>
        <article class="device-card"><div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px;"><h3>对服务而言</h3><span class="badge-tag">流程可落实</span></div><ul style="margin:0;padding-left:20px;color:#282224;font-size:14px;"><li style="margin:9px 0;padding-left:4px;">老师根据学员所报班型说明相应权益内容。</li><li style="margin:9px 0;padding-left:4px;">保障办理按照对应协议和服务流程进行核对。</li><li style="margin:9px 0;padding-left:4px;">重修与后续支持用于帮助学员继续完善备考准备。</li></ul></article>
      </div>
      <div class="service-notice"><strong>温馨提示：</strong>重修、复试支持、协议退费或奖励安排等权益，均对应具体课程产品与协议约定。学员最终考试与录取结果仍与个人基础、学习执行、目标院校要求及考试竞争情况有关。</div>
    </section>

    <section class="service-section faq">
      <div class="section-head"><h2>常见问题</h2></div>
      <details open><summary>清北博雅的保障类课程可以提供哪些支持？</summary><p>根据您选择的班型与协议约定，保障类课程可包含重修支持、复试辅导、协议约定的退费安排或奖励支持等内容。报名时老师可协助您对照产品权益进行了解。</p></details>
      <details><summary>我怎样确认自己享有重修权益？</summary><p>您可以查看本人所报课程名称、订单及已签署协议中的保障条款。选择了包含重修权益的班型，并符合协议列明条件后，可按照服务流程提出申请。</p></details>
      <details><summary>重修支持办理后，怎样继续学习？</summary><p>完成权益核对与申请确认后，老师会依据对应班型和协议安排，为您衔接相应课程或后续学习支持，具体课程范围和期限以协议内容为准。</p></details>
      <details><summary>班型包含复试支持时，如何使用？</summary><p>如您的课程权益中包含复试辅导，可结合初试后的学习阶段，按老师通知或服务流程进入相应复试课程与准备安排。</p></details>
      <details><summary>协议约定的退费或奖励安排如何办理？</summary><p>如您报名的班型包含相关约定，可按本人协议列明的适用条件、申请时间和办理路径提交申请，由服务老师协助完成核对与办理。</p></details>
    </section>
  </main>
</template>

<script>
export default {
  name: "RetakeGuide",
  data() {
    return {
      benefits: [
        { label: "重修支持", title: "继续备考有衔接", desc: "包含重修权益的班型，在符合协议约定条件后，可申请相应课程重修或次年学习支持，帮助学员继续推进备考计划。" },
        { label: "复试衔接", title: "初试之后有准备", desc: "部分高阶或全科班型配置复试辅导内容，为进入后续环节的学员提供复试准备与学习衔接支持。" },
        { label: "协议安排", title: "特定情形有约定", desc: "部分协议类、定制类或笔面联报课程，会在协议中列明相应退费处理方式，便于学员提前了解办理口径。" },
        { label: "学习激励", title: "达成目标可申请", desc: "部分管硕类保障班型设置奖励或奖学金安排，符合协议列明条件后，可按照流程提出申请。" },
      ],
      programs: [
        { icon: "公课", title: "公共课 SVIP 成硕计划", name: "政治 / 英语 / 数学相关 SVIP 课程", desc: "课程材料列有未录取后的重修支持；政治 SVIP 成硕计划列明可申请 1 年重修权限。", tags: ["重修支持"] },
        { icon: "管硕", title: "管硕保障类课程", name: "无忧、VIP、定制、协议、直通车及部分笔面班型", desc: "按班型可配置复试、重修、协议约定退费或奖励等权益，为笔试及笔面备考提供衔接支持。", tags: ["重修支持", "复试衔接", "协议权益"] },
        { icon: "教育", title: "教育类保障课程", name: "教育综合 333 VIP / 全科班；教育管理定向班型", desc: "相关班型列有重修服务，高阶全科班型还可配置复试课程；教育管理升级保障班列有持续重修支持。", tags: ["重修支持", "复试衔接"] },
        { icon: "法硕", title: "法硕保障课程", name: "VIP 高端私塾班 / VIP 全科班 / VIP 全科定制", desc: "产品及合同材料列有保障协议、未录取次年重修资格与初试通过后的复试指导课程。", tags: ["次年重修", "复试指导"] },
        { icon: "计", title: "计算机部分高阶课程", name: "相关定向、VIP 或直通全科产品", desc: "部分计算机高阶产品配置未过线后的重修全程班安排，并可结合产品设置提供复试学习支持。", tags: ["重修支持"] },
        { icon: "农硕", title: "农业硕士保障课程", name: "全科无忧班 / 特需定制班 / 尊享或高端协议班", desc: "对应产品可设置未录取重修或协议约定处理安排，为全科备考学员提供后续路径支持。", tags: ["重修支持", "协议权益"] },
        { icon: "396", title: "396 经济类综合高阶课程", name: "396 VIP 及相关组合课程", desc: "相关高阶班型列有复试或重修支持，可结合报名组合确认本人适用的课程权益。", tags: ["重修支持", "复试衔接"] },
        { icon: "线下", title: "线下协议班与集训营", name: "全年 / 半年协议班及相应全科协议产品", desc: "线下材料列有专属复试重修权益，其中相关协议班可按约申请线下科目重修或次年学习抵扣安排。", tags: ["线下重修", "学习抵扣"] },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/service-common.scss";
.service-hero {
  .lead { max-width: 930px; }
}
.benefit-card {
  border: 1px solid #ead7d8; border-radius: 14px; background: #fdfafa; padding: 19px 17px 17px; min-height: 177px;
  h3 { margin: 0 0 7px; color: #61030d; font-size: 17px; }
  p { margin: 0; color: #6d6062; font-size: 13px; line-height: 1.72; }
}
.benefit-label {
  display: inline-flex; background: #f8e8ea; color: #8c0b18; border-radius: 999px; padding: 3px 10px; margin-bottom: 11px; font-size: 12px; font-weight: 700;
}
.prog-card {
  display: flex; gap: 14px; border: 1px solid #ead7d8; border-radius: 14px; padding: 17px 17px 16px; background: #fff;
  h3 { font-size: 16px; color: #61030d; margin: 0 0 4px; }
  .prog-name { font-size: 13px; color: #6d6062; margin: 0 0 6px; }
  p { font-size: 13px; color: #6d6062; margin: 0; }
}
.prog-icon {
  flex: none; width: 40px; height: 40px; border-radius: 11px; background: #f8e8ea; color: #8c0b18;
  display: flex; align-items: center; justify-content: center; font-weight: 700; font-size: 14px;
}
.pill {
  display: inline-flex; border-radius: 999px; color: #8c0b18; background: #f8e8ea;
  font-weight: 700; font-size: 12px; padding: 3px 9px; margin: 7px 5px 0 0;
}
.device-card {
  border: 1px solid #ead7d8; border-radius: 16px; background: #fbfdff; padding: 22px 23px;
  h3 { margin: 0; color: #61030d; font-size: 20px; }
}
.badge-tag { background: #f8e8ea; color: #8c0b18; font-size: 12px; font-weight: 700; padding: 4px 10px; border-radius: 999px; }
</style>
